import axios from "axios";

export const getSummaryReport = async (accountId, startDate, endDate) => {
  const data = await axios.get(
    `${process.env.VUE_APP_API_GMB_URL_GOOGLE}/linkedin/${accountId}/full-report?start_date=${startDate}&end_date=${endDate}`
  );
  return data.data;
};
